import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { InputComponent, ButtonComponent, ToastService } from '@/shared/components';
import { AuthService } from '@/services/auth.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, RouterLink, FormsModule, InputComponent, ButtonComponent],
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent {
  email = '';
  isLoading = false;
  submitted = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastService: ToastService
  ) {}

  onSubmit() {
    this.submitted = true;

    if (!this.email || !this.isValidEmail(this.email)) {
      return;
    }

    this.isLoading = true;

    this.authService.requestPasswordReset(this.email).subscribe({
      next: () => {
        this.toastService.show('success', `Código enviado para ${this.maskEmail(this.email)}`);
        this.isLoading = false;
        // Navigate to verification code screen with email
        this.router.navigate(['/recuperar-senha/verificar'], {
          state: { email: this.email }
        });
      },
      error: (error) => {
        console.error('Error requesting password reset:', error);
        this.isLoading = false;
        const errorMessage = error.error?.message || 'Erro ao enviar código. Verifique o email e tente novamente.';
        this.toastService.show('error', errorMessage);
      }
    });
  }

  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  maskEmail(email: string): string {
    const [localPart, domain] = email.split('@');
    if (localPart.length <= 2) {
      return `${localPart[0]}***@${domain}`;
    }
    const maskedLocal = localPart[0] + '*'.repeat(localPart.length - 2) + localPart[localPart.length - 1];
    return `${maskedLocal}@${domain}`;
  }
}
